(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meller-mas-mellers-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__mellerCartUpsellBound) return;

    window.__mellerCartUpsellBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-meller-cart-upsell-arrow]');
      if (!button) return;

      const section = button.closest('.meller-cart-upsell');
      if (!section) return;

      const scroller = section.querySelector('[data-meller-cart-upsell-scroller]');
      if (!scroller) return;

      const direction = button.getAttribute('data-meller-cart-upsell-arrow') === 'next' ? 1 : -1;
      const firstCard = scroller.querySelector('.meller-cart-upsell__item');
      const styles = window.getComputedStyle(scroller);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : scroller.clientWidth * 0.85;
      const distance = cardWidth + gap;

      scroller.scrollBy({
        left: direction * distance,
        behavior: 'smooth'
      });
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meller-scheduled-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('meller-hero-category-picker')) {
    customElements.define('meller-hero-category-picker', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const details = this.querySelector('details');
        const trigger = this.querySelector('summary');
        const track = this.closest('[data-scheduled-hero-track]');
        if (!details || !trigger) return;
        trigger.setAttribute('aria-expanded', String(details.open));
        details.addEventListener('toggle', () => {
          trigger.setAttribute('aria-expanded', String(details.open));
        }, options);
        let openedByHover = false;
        const close = () => {
          details.open = false;
          openedByHover = false;
        };
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches && !details.open) {
            details.open = true;
            openedByHover = true;
          }
        }, options);
        // Browsers may fire pointerleave from a finger lift before the click.
        // Only mouse hover can dismiss this menu by leaving the picker.
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse' ||
              !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          if (!this.contains(document.activeElement)) close();
        }, options);
        trigger.addEventListener('click', (event) => {
          if (openedByHover && event.detail > 0) {
            event.preventDefault();
            openedByHover = false;
          }
        }, options);
        // On iOS/Android, focus may move before the link click is dispatched.
        // Limit blur dismissal to devices with a fine hover pointer.
        this.addEventListener('focusout', (event) => {
          if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            close();
            trigger.focus({ preventScroll: true });
          }
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (!this.contains(event.target)) close();
        }, options);
        // Keep the native <a href> active for the full touch click sequence.
        // Do not close on hero scroll/snap; the picker moves with its slide.
        // Outside pointerdown and Escape already provide safe dismissal.
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
